import { FC } from "react";
import { useSelector } from "react-redux";

import placeholder from "web/assets/images/placeholder.jpg";

import getAutoresizeSrc from "web/utils/system/url/getAutoresizeSrc";
import getSrcMedia from "web/utils/system/url/getSrcMedia";

import { IStoreConfig } from "web/types/StoreConfig";
import { Nullable } from "web/types/Utils";

import LazyLoadImage from "./lazyLoadImage";

interface ILazyLoadImageContainerProps {
  src: Nullable<string>;
  alt?: string;
  width?: Nullable<number>;
  height?: Nullable<number>;
  dataT1?: string;
  isProduct?: boolean;
  isCategory?: boolean;
  isCampaign?: boolean;
  isAutoresized?: boolean;
  notProcessed?: boolean;
  className?: string;
}

const LazyLoadImageContainer: FC<ILazyLoadImageContainerProps> = ({
  src = null,
  alt = "",
  width = null,
  height = null,
  dataT1 = "image",
  isProduct = false,
  isCategory = false,
  isCampaign = false,
  isAutoresized = true,
  notProcessed = false,
  className,
}) => {
  const storeConfig = useSelector(
    (state) => state.app.storeConfig
  ) as IStoreConfig;
  const imagePathCreator = isAutoresized ? getAutoresizeSrc : getSrcMedia;
  const srcProcessed = src
    ? imagePathCreator({
        storeConfig,
        src,
        width,
        height,
        isProduct,
        isCategory,
        isCampaign,
      })
    : placeholder;

  return (
    <LazyLoadImage
      src={notProcessed ? src : srcProcessed}
      alt={alt}
      height={height}
      dataT1={`${dataT1}_${alt}_${src}`}
      className={className}
    />
  );
};

export default LazyLoadImageContainer;
